<div class="checkin__footer checkin__layout">
  <span class="checkin__footer__copyright">{{ text }}</span>
</div>
